import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ButtonComponent } from '../../buttons/button/button.component';
import { BannerButtonConfig, BannerConfig, BannerStyle } from '../banner-config';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-small-banner',
  imports: [MatIcon, ButtonComponent],
  templateUrl: './small-banner.component.html',
  styleUrl: './small-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallBannerComponent {
  readonly config = input<BannerConfig | undefined>(undefined);
  readonly title = input<string | undefined>(undefined);
  readonly icon = input<string | undefined>();
  readonly description = input<string | undefined>(undefined);
  readonly style = input<BannerStyle>(BannerStyle.Info);
  readonly buttons = input<BannerButtonConfig[] | undefined>(undefined);

  protected adjustedConfig = computed(() => {
    const config = this.config();
    if (config) return config;

    return {
      title: this.title(),
      icon: this.icon(),
      description: this.description(),
      style: this.style(),
      buttons: this.buttons(),
    } satisfies BannerConfig;
  });

  protected readonly BannerStyle = BannerStyle;
  protected readonly InputSize = InputSize;
}
